/**
 * Google Ads conversion tracking helpers, RGPD-safe.
 * Safe no-op if gtag isn't loaded (user hasn't consented to analytics cookies).
 *
 * Enhanced Conversions: when a hashed email/phone is provided, we call
 * gtag('set','user_data',...) with SHA-256 (per Google Ads spec) *just before*
 * firing the conversion event. This improves match rate for Google Ads
 * attribution but requires the user's consent (analytics gate applies).
 */

const FORM_CONVERSION = "AW-18117412144/Xw9VCKGjsMwcELCKh79D";
const PHONE_CONVERSION = "AW-18117412144/zmXcCKSjsMwcELCKh79D";

function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}

function normalizePhone(phone) {
  // E.164 without spaces / dots / hyphens
  return String(phone || "").replace(/[^\d+]/g, "");
}

async function sha256Hex(text) {
  if (!text) return null;
  if (typeof window === "undefined" || !window.crypto || !window.crypto.subtle) return null;
  const enc = new TextEncoder().encode(text);
  const buf = await window.crypto.subtle.digest("SHA-256", enc);
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

async function fire(sendTo, userData) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return; // gtag not loaded → no consent
  try {
    if (userData && (userData.email || userData.phone)) {
      const payload = {};
      if (userData.email) {
        const h = await sha256Hex(normalizeEmail(userData.email));
        if (h) payload.sha256_email_address = h;
      }
      if (userData.phone) {
        const h = await sha256Hex(normalizePhone(userData.phone));
        if (h) payload.sha256_phone_number = h;
      }
      if (Object.keys(payload).length > 0) {
        window.gtag("set", "user_data", payload);
      }
    }
    window.gtag("event", "conversion", { send_to: sendTo });
  } catch (e) {
    // silent
  }
}

/**
 * Track a form-inscription conversion.
 * @param {{email?: string, phone?: string}} [userData]  optional enhanced-conversion payload
 */
export function trackFormConversion(userData) { return fire(FORM_CONVERSION, userData); }

/**
 * Track a phone-call conversion (no enhanced data available on click).
 */
export function trackPhoneConversion() { return fire(PHONE_CONVERSION); }
